// extracted by mini-css-extract-plugin
export var badge = "cart-button-module--badge--2932c";
export var cartButton = "cart-button-module--cartButton--17e8b";
export var cartButtonBlack = "cart-button-module--cartButtonBlack--4637f";
export var cartButtonWhite = "cart-button-module--cartButtonWhite--bfe46";